export default __webpack_public_path__ + "static/media/quilmes.18c5587f.svg";